// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TSDScanner_container__GGxCk {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}

.TSDScanner_input__yJNJh {
  width: 100%;
  max-width: 320px;
  font-size: 18px;
  padding: 10px 14px;
  border: 2px solid #ccc;
  border-radius: 8px;
  outline: none;
  background: #fff;
  color: #333;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.TSDScanner_input__yJNJh:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/modules/Storekeeper/ContainersPage/ContainerScannerModal/Scanners/TSDScanner.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":[".container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 12px;\r\n}\r\n\r\n.input {\r\n  width: 100%;\r\n  max-width: 320px;\r\n  font-size: 18px;\r\n  padding: 10px 14px;\r\n  border: 2px solid #ccc;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  background: #fff;\r\n  color: #333;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.input:focus {\r\n  border-color: #4a90e2;\r\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TSDScanner_container__GGxCk`,
	"input": `TSDScanner_input__yJNJh`
};
export default ___CSS_LOADER_EXPORT___;
